module.exports = __webpack_public_path__ + "static/img/sidebar-2.1fed358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-2.jpg
// module id = 1691
// module chunks = 31